/**
 * Экранирует текст инструкции и делает ссылки кликабельными.
 * Поддержка:
 * - markdown: [текст](https://example.com)
 * - голые URL: https://example.com
 * Бэк хранит plain string — форматирование только на фронте.
 */
export function formatGuideText(text: string): string {
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  const placeholders: string[] = []

  // [подпись](https://...) → кликабельная подпись
  let result = escaped.replace(
    /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
    (_match, label: string, url: string) => {
      const index = placeholders.length
      placeholders.push(
        `<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`,
      )
      return `\0LINK${index}\0`
    },
  )

  // Оставшиеся голые URL
  result = result.replace(
    /(https?:\/\/[^\s<&\0]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  )

  result = result.replace(/\0LINK(\d+)\0/g, (_match, index: string) => placeholders[Number(index)])

  return result.replace(/\n/g, '<br>')
}
